import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  DateInput,
  required,
  minValue,
} from "react-admin";
import type { EditProps } from "react-admin";

export const ProjectKarzanRepaymentEdit = (props: EditProps) => (
  <Edit
    {...props}
    transform={(data: Record<string, unknown>) => ({
      amount: Number(data.amount),
      repaymentDate: data.repaymentDate,
      remarks: typeof data.remarks === "string" ? data.remarks.trim() || undefined : data.remarks,
    })}
  >
    <SimpleForm>
      <NumberInput source="amount" validate={[required(), minValue(1)]} />
      <DateInput source="repaymentDate" validate={required()} />
      <TextInput source="remarks" multiline fullWidth />
    </SimpleForm>
  </Edit>
);
